import moment from 'moment';
import { getValuationsStatuses } from '../../HttpRequests/valuationStatuses';
import { loadValuationStatuses } from '../State/valuationStatuses';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const response = await getValuationsStatuses();

    dispatch(loadValuationStatuses(response.data.data));

  } catch (error) {
    
    throw error;

  }
}